import React, { FC, useState } from 'react'
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react'
import { CloseIcon, SearchIcon } from './SearchIcons'

interface SearchInputProps {
  placeholder: string
  onSearch: (value: string) => void
}

export const SearchInput = ({ placeholder, onSearch }: SearchInputProps) => {
  const [value, setValue] = useState('')

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') handleSearch()
  }

  const handleResetInput = () => {
    setValue('')
    onSearch('')
  }

  const handleSearch = () => onSearch(value)

  return (
    <InputGroup position={'relative'}>
      <InputLeftElement top={'10px'} width={'40px'} left={'10px'}>
        <SearchIcon style={{ cursor: 'pointer' }} onClick={handleSearch} />
      </InputLeftElement>
      {value && (
        <InputRightElement top={'10px'} right={'10px'}>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={handleResetInput} />
        </InputRightElement>
      )}
      <Input
        placeholder={placeholder}
        value={value}
        onKeyDown={handleKeyPress}
        onChange={handleOnChange}
        borderRadius={'8px'}
        height={'60px'}
        width={'100%'}
        paddingLeft={'60px'}
        paddingRight={'60px'}
        bg='linear-gradient(175deg, #26272a, #16171b)'
        _placeholder={{ color: '#4F4F4F' }}
        _focus={{
          bg: '#000',
          borderColor: 'transparent',
        }}
        _hover={{
          bg: 'linear-gradient(5deg, #26272a, #16171b)',
        }}
      />
    </InputGroup>
  )
}
